<template>
	<div>
		<el-form label-position="left" label-width="80px" :model="transferForm" ref="transferForm">
			<el-form-item prop="fsIp" label="转接类型：">
				<el-select v-model="transferForm.type" size="small" filterable>
					<el-option v-for="item in [{id: '*20', name: '监听'}, {id: '*21', name: '耳语'}, {id: '*22', name: '强插'}]" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item prop="phone" label="分机号：">
				<el-select v-model="transferForm.phone" size="small" filterable>
					<el-option v-for="item in extensList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div style="text-align: center;margin-top: 18px;">
			<el-button @click="handleBusyOperate" :loading="loading" size="mini" type="primary">确 认</el-button>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
	props: ['sipDriver'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			transferForm: {
				type: '*20',
				phone: '',
			},
			extensList: [],
			loading: false,
		}
	},
	mounted() {
		this.extensList = [];
		this.$api.apiPostProjectExtensList({
			projectCode: this.userInfo.brandIdentify,
		}).then(response => {
			if(response.errcode != 0) return;
			for(const item of response.data) {
				if(item.ext != this.userInfo.deviceCode) {
					this.extensList.push({
						id: item.ext,
						name: item.nickname
					});
				}
			}
		});
	},
	methods: {
		...mapMutations({
			'SET_SOFT_PHONE_IN_MSG': 'telService/SET_SOFT_PHONE_IN_MSG',
			'SET_IS_MONITOR': 'telService/SET_IS_MONITOR',
			'SET_IS_ANSWER': 'telService/SET_IS_ANSWER'
		}),
		handleBusyOperate() {
			if(!this.transferForm.phone){
				this.$message.error(`请选择分机号`);
				return;
			}
			this.SET_SOFT_PHONE_IN_MSG({
				msg: `监听、耳语、强插: 号码: ${this.transferForm.phone} 类型: ${this.transferForm.type}`,
			});
			this.SET_IS_MONITOR(true);
			this.SET_IS_ANSWER(true);
			this.sipDriver._monitor(`${this.transferForm.type}${this.transferForm.phone}`);
			this.$emit('signClose');
			this.loading = false;
		},
	}
}
</script>